if (!customElements.get('variant-selects')) {
    customElements.define(
        'variant-selects',
        class VariantSelects extends HTMLElement {
            constructor() {
                super();
            }

            get selectedOptionValues() {
                return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
                    ({dataset}) => dataset.optionValueId
                );
            }

            getInputForEventTarget(target) {
                return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
            }

            connectedCallback() {
                if (this.attributes['selected-variant']?.value) {
                    const variantChanged = new CustomEvent('variant-changed', {
                        detail: {
                            value: this.attributes['selected-variant'].value,
                        },
                    });
                    if (this.attributes['selected-variant'].value === 'Customized Message (+AED 30.00)') {
                        if(document.querySelector('.custom_message')){
                            document.querySelector('.custom_message').classList.remove('hidden'); 
                        }
                    }else{
                        if(document.querySelector('.custom_message')){
                            document.querySelector('.custom_message').classList.add('hidden'); 
                        }
                    }
                    localStorage.setItem('selected-variant-title', this.attributes['selected-variant'].value);
                    document.dispatchEvent(variantChanged);
                }
                this.addEventListener('change', (event) => {
                    const target = this.getInputForEventTarget(event.target);
                    this.updateSelectedSwatchValue(event);
                    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
                        data: {
                            event,
                            target,
                            selectedOptionValues: this.selectedOptionValues,
                        },
                    });
                });
            }

            updateSelectedSwatchValue({target}) {
                const {value, tagName} = target;

                if (tagName === 'SELECT' && target.selectedOptions.length) {
                    Array.from(target.options)
                        .find((option) => option.getAttribute('selected'))
                        .removeAttribute('selected');
                    target.selectedOptions[0].setAttribute('selected', 'selected');

                    const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
                    const selectedDropdownSwatchValue = target
                        .closest('.product-form__input')
                        .querySelector('[data-selected-value] > .swatch');
                    if (!selectedDropdownSwatchValue) return;
                    if (swatchValue) {
                        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
                        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
                    } else {
                        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
                        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
                    }
                    selectedDropdownSwatchValue.style.setProperty(
                        '--swatch-focal-point',
                        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
                    );
                } else if (tagName === 'INPUT' && target.type === 'radio') {
                    const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
                    if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
                }
            }
        }
    );
}
